import c from "classnames";
import { ComponentProps, PropsWithChildren, useEffect } from "react";
import { Path, UseFormSetError } from "react-hook-form";

import classes from "./Form.module.css";

type FormFieldValue = string | number | boolean | null | undefined;

type Props<T extends Record<string, FormFieldValue>> = PropsWithChildren &
  ComponentProps<"form"> & {
    /**
     * Errors from the API
     */
    errorsAPI?: Record<string, string>;
    /**
     * Function to set the error for the field
     */
    setError?: UseFormSetError<T>;
    grow?: boolean;
  };

export const Form = <T extends Record<string, FormFieldValue>>({
  errorsAPI,
  setError,
  grow,
  ...rest
}: Props<T>) => {
  useEffect(() => {
    if (errorsAPI && setError) {
      Object.entries(errorsAPI).forEach(([field, error]) => {
        setError(field as Path<T>, { message: error });
      });
    }
  }, [errorsAPI, setError]);

  return <form className={c(classes.form, grow && classes.grow)} {...rest} />;
};
